import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const n1 = Math.floor(Math.random() * 5) + 1;  // pierwszy numer wyrazu
  const r = Math.floor(Math.random() * 10) - 5;  // różnica
  const k = Math.floor(Math.random() * 5) + 2;   // odległość między wyrazami
  const n2 = n1 + k;

  const a1 = Math.floor(Math.random() * 20) - 10; // wartość wyrazu n1
  const a2 = a1 + (n2 - n1) * r;                  // wartość wyrazu n2

  return {
    type: "FindDifferenceTask",
    data: { n1, n2, a1, a2, r }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { n1, a1, n2, a2 } = data;

  return (
    <>
      <p>
        Dany jest ciąg arytmetyczny, w którym{" "}
        <InlineMath math={`a_{${n1}} = ${a1}`} /> oraz{" "}
        <InlineMath math={`a_{${n2}} = ${a2}`} />.
      </p>
      <p>
        Oblicz różnicę <InlineMath math="r" /> tego ciągu.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  if (given === null) return false;

  return Math.abs(given - data.r) < 0.01;
}

export function renderAnswer({ data }) {
  return (
    <InlineMath math={`r = ${data.r}`} />
  );
}

export function renderExplanation({ data }) {
  const { n1, n2, a1, a2, r } = data;

  const deltaN = n2 - n1;
  const deltaA = a2 - a1;

  const formattedDeltaA = deltaA;
  const formattedR = r;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Ogólny wzór ciągu arytmetycznego i przekształcenie do <InlineMath math="r" />:
      </p>
      <BlockMath math={`a_n = a_k + (n-k) \\cdot r`} />
      <BlockMath math={`r = \\frac{a_n - a_k}{n-k}`} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy i obliczamy:
      </p>
      <BlockMath math={`r = \\frac{${a2} - (${a1})}{${n2} - ${n1}}`} />
      <BlockMath math={`r = \\frac{${formattedDeltaA}}{${deltaN}}`} />
      <BlockMath math={`r = ${formattedR}`} />
    </div>
  );
}


export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return (
    <InlineMath math={`r = ${userAnswer.raw}`} />
  );
}
